export default idx => {
    return String.fromCharCode(65 + idx)
}
